import React from 'react'
import Invoice_header from '../Header/Invoice_header'
import "../../styles/scope.css";
import { useState, useRef, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify"
import DatePicker from "react-datepicker";
import ReactPaginate from "react-paginate";
import { useNavigate } from 'react-router-dom';
import "../../styles/invoice_addnew.css";
import excel_icon from "../../assets/svg/excel_icon.svg";
import upload_icon from "../../assets/svg/upload_icon.svg";
import download_icon from "../../assets/svg/download_icon.svg";
import axios from 'axios';
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import filterOpenCloseIcon from "../../assets/svg/filterOpenCloseIcon.svg";
import checked_icon from "../../assets/svg/checked_icon.svg";
import removed_icon from "../../assets/svg/removed_icon.svg";
import axiosInstance from '../../axiosInstance';
import download_arrow from "../../assets/svg/download_arrow.svg";
import { usePermissions } from '../../hooks/PermissionContext';
import PermissionWrapper from '../../hooks/PermissionWrapper';
import AdditionalPermissionWrapper from '../../hooks/AdditionalPermissionWrapper';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../../CommonFooter/CommonFooter';
import { FaChevronDown } from "react-icons/fa";
import AsyncSelect from "react-select/async";
import CommonPagination from '../../CommonPagination/CommonPagination';
import CostApproveRejectPopup from './CostApproveRejectPopup';
import CostInvoiceFilter from './CostInvoiceFilter';

const CostInvoice = () => {

    let ModuleId = 24
    const { getModulePermission } = usePermissions();
    const permission = getModulePermission(ModuleId);
    console.log("activeModuleId", ModuleId);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [tableData, setTableData] = useState([]);
    const [error, setError] = useState(null);
    const [limit, setLimit] = useState(5);
    const [actionType, setActionType] = useState("");
    const [isModalOpen, setModalOpen] = useState(false);
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const [skip, setSkip] = useState(0);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const popupRef = useRef(null);
    const [activeInvoice, setActiveInvoice] = useState(null);
    const [editData, setEditData] = useState(null);
    const [activeTab, setActiveTab] = useState("all");
    const [showSapButton, setShowSapButton] = useState(false);
    const [showBulkSubmitButton, setShowBulkSubmitButton] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [confirmBulkSubmitOpen, setConfirmBulkSubmitOpen] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState([]);
    const [staticProject, setStaticProject] = useState([]);
    const [openByArrow, setOpenByArrow] = useState(false);
    const [showFilters, setShowFilters] = useState(true);
    const [filterDateRange, setFilterDateRange] = useState([null, null]);
    const [fromDate, toDate] = filterDateRange;
    const [appliedFilters, setAppliedFilters] = useState({});
    const [selectedVendor, setSelectedVendor] = useState([]);
    const [approvalData, setApprovalData] = useState(null);
    const [isActionLoading, setIsActionLoading] = useState(false);
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    const [zone, setZone] = useState([]);
    const [plantCode, setPlantCode] = useState([]);
    const [purchaseInvNumber, setPurchaseInvNumber] = useState("");
    const [showFilter, setShowFilter] = useState(true);
    const [divisionType, setDivisionType] = useState("");
    const [uploadedFiles, setUploadedFiles] = useState({
        UPLOAD: [],
        SI: [],
    });
    const [loading, setLoading] = useState(false);
    const [sortBy, setSortBy] = useState("dateCreated");
    const [statusCounts, setStatusCounts] = useState({
        all: 0,
        draft: 0,
        submitted: 0,
        rejected: 0,
        sapPushed: 0,
        final: 0
    });

    const calculateStatusCounts = (total) => {
        return {
            all: total,
            draft: total,
            submitted: total,
            rejected: total,
            sapPushed: total,
            final: total
        };
    };

    const openModal = async (type, invoice) => {
        setActionType(type);
        setActiveInvoice(invoice);

        const data = await fetchApprovalData(invoice.id);

        if (data) {
            setApprovalData(data);
            setModalOpen(true);
        }
    };

    const closeModal = () => {
        setModalOpen(false);
        setComment("");
    };

    useEffect(() => {
        if (tableData.length > 0) {
            setStatusCounts(calculateStatusCounts(total));
        }
        console.log("totalcount", total);
    }, [tableData]);

    const handleSapPush = async () => {
        try {
            console.log('Sending SAP trigger request with invoice IDs:', selectedRows);

            const response = await axiosInstance.post('/sap_trigger', {
                invoice_ids: selectedRows
            });

            console.log('SAP trigger response:', response);

            if (response.status === 200) {
                toast.success("SAP push successful!");
                setSelectedRows([]);
                setShowSapButton(false);
                // Consider refreshing the data after successful push
                fetchData();
            } else {
                toast.error(`SAP push failed! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("SAP push error:", {
                message: error.message,
                response: error.response,
                stack: error.stack
            });

            let errorMessage = "Something went wrong with SAP push!";
            if (error.response) {
                errorMessage += `\nStatus: ${error.response.status}`;
                if (error.response.data) {
                    errorMessage += `\nError: ${JSON.stringify(error.response.data)}`;
                }
            }
            toast.error(errorMessage);
        }
    };

    const handleBulkSubmit = () => {
        if (selectedRows.length === 0) return;
        setConfirmBulkSubmitOpen(true);
    };

    const confirmBulkSubmit = async () => {
        setConfirmBulkSubmitOpen(false);

        try {
            // Correct API call for bulk submit
            const response = await axiosInstance.post('/invoice/draft_bulkSubmit', {
                invoice_ids: selectedRows
            });

            console.log('Invoice Draft Bulk Submit response:', response);

            if (response.data.success) {
                toast.success(`${selectedRows.length} invoices submitted successfully!`);

                setSelectedRows([]);
                setShowBulkSubmitButton(false);

                const payload = {
                    skip: 0,
                    limit: limit,
                    type: 'cost',
                    filter: {
                        status: "draft",
                    },
                };
                fetchData(payload);
            } else {
                toast.error(response.data.message || "Failed to submit invoices");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to submit invoices");
            console.error("Bulk submit error:", error);
        }
    };

    const cancelBulkSubmit = () => {
        setConfirmBulkSubmitOpen(false);
    };


    const handleInvoiceAction = async (invoiceId, projectIds, vendorId, data) => {
        if (!data.comments?.trim()) {
            toast.error("Comment is required");
            return;
        }
        setIsActionLoading(true);
        const payload = {
            invoice_id: invoiceId,
            // project_ids: projectIds,
            vendor_id: vendorId,
            module: "3",
            invoice_type: "cost",
            comments: data.comments,
            status: actionType,
            cost_header_remarks: data.cost_header_remarks,
            ...(data.tax_code && { tax_code: data.tax_code }),
            // ...(data.plant_code && {
            //     plant_id: data.plant_id,
            //     plant_code: data.plant_code
            // })
        };

        console.log("payload checkkkkkkkkk listingg", payload);


        try {
            const response = await axiosInstance.post(`/approve_reject_btns`, payload);

            console.log("approve_reject response", response);

            if (response.status === 200) {
                toast.success(`Invoice ${actionType} successfully!`);

                const payload = {
                    skip: 0,
                    limit: limit,
                    type: 'cost',
                    filter: {
                        status: activeTab,
                    },
                };
                fetchData(payload);
                // navigate(-1);
            } else {
                toast.error(`Failed to ${actionType} invoice: ${response.data.message || 'Unknown error'}`);
            }

        } catch (error) {
            console.error(`Error ${actionType} invoice:`, error);
            toast.error(`An error occurred while ${actionType} the invoice`);
        } finally {
            setIsActionLoading(false);
            closeModal();
        }
    };



    // useEffect(() => {
    //     const payload = {
    //         // Example payload data; adjust as required by your API
    //         skip: 0,
    //         limit: 5
    //     };
    //     console.log("fetch api called");
    //     fetchData(payload);
    // }, []);


    useEffect(() => {
        setSelectedInvoice([]);
        setPurchaseInvNumber("");
        setStaticProject([]);
        setSelectedVendor([]);
        setDivisionType("");
        setPlantCode([]);
        setFilterDateRange([null, null]);
        setAppliedFilters({});
        setCity([]);
        setState([]);
        setZone([]);
        setCurrentPage(0);
        setSkip(0);

        fetchAllCost();
    }, [activeTab]);

    const fetchAllCost = () => {
        fetchData({
            skip: 0,
            limit,
            type: "cost",
            filter: {
                status: activeTab.toLowerCase()
            },
            search: searchTerm
        });
    };

    const formatDate = (date) => {
        if (!date) return null;
        return date.toISOString().split("T")[0];
    };

    const handleApply = () => {
        const filters = {
            status: activeTab.toLowerCase(),
            inv_number: selectedInvoice && selectedInvoice.length > 0 ? selectedInvoice.map(v => v.value) : [],
            project: staticProject && staticProject.length > 0 ? staticProject.map(v => v.value) : [],
            vendor: selectedVendor && selectedVendor.length > 0 ? selectedVendor.map(v => v.value) : [],
            plant_code: plantCode && plantCode.length > 0 ? plantCode.map(v => v.value) : [],
            purchase_inv_number: purchaseInvNumber || null,
            from_date: fromDate ? formatDate(fromDate) : null,
            to_date: toDate ? formatDate(toDate) : null,
            city: city && city.length > 0 ? city.map(v => v.value) : [],
            state: state && state.length > 0 ? state.map(v => v.value) : [],
            zones: zone && zone.length > 0 ? zone.map(v => v.value) : [],
            division_type: divisionType || null

        };

        const { status, ...restFilters } = filters;

        const isEmpty = Object.values(restFilters).every(
            (val) => {
                if (Array.isArray(val)) {
                    return val.length === 0;
                }
                return val === null || val === "" || val === undefined;
            }
        );

        if (isEmpty) {
            toast.warning("Please select at least one filter before applying.");
            return;
        }

        setAppliedFilters(filters);
        setCurrentPage(0);
        setSkip(0);
        console.log("Applied Filters:", filters);
        fetchData({
            skip: 0,
            limit,
            type: "cost",
            filter: filters,
            search: searchTerm
        });
    };


    const fetchData = async (payload) => {
        try {

            const requestPayload = payload || {
                skip: skip,
                type: 'cost',
                limit: limit,
                sortBy: sortBy,
                filter: {
                    status: activeTab.toLowerCase()
                },
                search: searchTerm
            };

            // const response = await axios.post(
            //     'https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/invoice/invoice_list',
            //     requestPayload,
            // );

            const response = await axiosInstance.post(
                '/invoice/invoice_list',
                requestPayload,
            );

            console.log("invoice list response", response);

            if (response.data && Array.isArray(response.data.job)) {
                setTableData(response.data.job);
                const newTotal = response.data.totalCount || 0;
                setTotal(newTotal);
                setTotalPages(Math.ceil(newTotal / limit));
            } else {
                setTableData([]);
                setTotal(0);
                setTotalPages(0);
            }
        } catch (error) {
            setError(error.message);
            console.error("There was a problem with the API request:", error);
        } finally {
            setLoading(false);
        }
    };



    // Rest of your useEffect hooks remain the same
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                closePopup();
            }
        };
        if (isPopupOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isPopupOpen]);

    const handlePageClick = ({ selected }) => {
        const newSkip = selected * limit;
        setCurrentPage(selected);
        setSkip(newSkip);

        // const status = activeTab.toLowerCase();

        // const payload = {
        //     limit: limit,
        //     type: 'cost',
        //     skip: newSkip,
        //     filter: {
        //         status: status,
        //     },
        //     search: searchTerm
        // };
        // fetchData(payload);


        fetchData({
            skip: newSkip,
            limit,
            type: 'cost',
            filter: {
                status: activeTab.toLowerCase(),
                ...appliedFilters
            },
            search: searchTerm
        });
    };


    const handleFileUpload = (event, type, rowIndex) => {
        const files = event.target.files;

        if (files.length > 0) {
            setUploadedFiles(prevFiles => ({
                ...prevFiles,
                [rowIndex]: {
                    ...prevFiles[rowIndex],
                    [type]: [...(prevFiles[rowIndex]?.[type] || []), ...files]
                }
            }));
        }
    };

    const removeFile = (rowIndex, type) => {
        setUploadedFiles(prevFiles => {
            const updatedFiles = { ...prevFiles };
            if (updatedFiles[rowIndex]?.[type]) {
                delete updatedFiles[rowIndex][type]; // Remove file entry
            }
            return updatedFiles;
        });
    };

    const handleLimitChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(0);
        setSkip(0);

        const status = activeTab.toLowerCase();

        const payload = {
            limit: newLimit,
            skip: 0,
            type: 'cost',
            filter: {
                status: status,
            },
            search: searchTerm
        };
        fetchData(payload);
    };


    const handleDateSelection = (date) => {
        console.log("Selected Date:", date);
    };

    const navigate = useNavigate();

    const handleAddNewClick = () => {
        navigate("/invoice_addNew");
    };

    const closePopup = () => {
        setEditData(null);
        setIsPopupOpen(false);
    };

    const isAllSelected = selectedRows.length === tableData.length;
    const isAnySelected = selectedRows.length > 0;

    const handleSelectAll = () => {
        const newSelected = isAllSelected ? [] : tableData.map((row) => row.id);
        setSelectedRows(newSelected);
        // // Show SAP button only if all selected are completed
        // setShowSapButton(newSelected.length > 0 && tableData.every(row =>
        //     newSelected.includes(row.id) && row.approval_status.toLowerCase() === "completed"
        // ));

        setShowBulkSubmitButton(newSelected.length > 0 && tableData.every(row =>
            newSelected.includes(row.id) && row.approval_status.toLowerCase() === "draft"
        ));
    };

    const handleRowSelect = (id) => {
        const newSelected = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];

        setSelectedRows(newSelected);

        // Get all selected invoices
        const selectedInvoices = tableData.filter(row => newSelected.includes(row.id));

        // Show SAP button only if at least one selected is completed
        // and none are in invalid states
        // const hasCompleted = selectedInvoices.some(inv =>
        //     inv.approval_status.toLowerCase() === "completed"
        // );

        // const hasInvalid = selectedInvoices.some(inv =>
        //     !["completed"].includes(inv.approval_status.toLowerCase())
        // );

        // setShowSapButton(newSelected.length > 0 && hasCompleted && !hasInvalid);



        // Show Bulk Submit button only if at least one selected is draft
        // and none are in invalid states
        const hasDraft = selectedInvoices.some(inv =>
            inv.approval_status.toLowerCase() === "draft"
        );

        const hasDraftInvalid = selectedInvoices.some(inv =>
            !["draft"].includes(inv.approval_status.toLowerCase())
        );

        setShowBulkSubmitButton(newSelected.length > 0 && hasDraft && !hasDraftInvalid);
    };

    const handleDelete = (id) => {
        setDeleteId(id);
        setConfirmOpen(true);
    };

    const confirmDelete = async () => {
        if (!deleteId) return;

        try {
            const response = await axiosInstance.delete(
                `/invoice/delete/${deleteId}`
            );

            if (response.status === 200) {
                toast.success("Invoice deleted successfully!");
                setTableData((prevData) => prevData.filter((row) => row.id !== deleteId));
                setTotal((prevTotal) => prevTotal - 1);
                fetchData();
            } else {
                toast.error(`Failed to delete the invoice! ${response.statusText}`);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong while deleting!");
        } finally {
            setConfirmOpen(false);
            setDeleteId(null);
        }
    };

    const cancelDelete = () => {
        setConfirmOpen(false);
        setDeleteId(null);
    };

    // Filter invoices based on active tab
    const filteredInvoices = tableData.filter(inv => {
        if (activeTab === "all") return true;
        // if (activeTab === "completed") return inv.approval_status === "Completed" || "completed";
        if (activeTab === "sap pushed") return inv.approval_status === "sap pushed";
        if (activeTab === "final invoice") return inv.approval_status === "final invoice";
        // if (activeTab === "submitted") return inv.approval_status === "submitted";
        if (activeTab === "submitted") return ["submitted", "approved"].includes(inv.approval_status);
        if (activeTab === "rejected") return inv.approval_status === "rejected";
        if (activeTab === "draft") return inv.approval_status === "draft";
        return true;
    });

    const createClickHandler = (invoice) => {
        return () => {
            const status = invoice.approval_status.toLowerCase();
            if (status === "submitted" || status === "draft" || status === "rejected") {
                navigate("/costInvoiceViewPage", { state: { invoice } });
            }
        };
    };

    const handleSearch = async (searchValue) => {
        setSearchTerm(searchValue);

        setCurrentPage(0);
        setSkip(0);

        // const status = activeTab.toLowerCase();

        // const payload = {
        //     skip: 0,
        //     limit: limit,
        //     type: 'cost',
        //     filter: {
        //         status: status,
        //     },
        //     search: searchValue
        // };

        fetchData({
            skip: 0,
            limit,
            type: 'cost',
            filter: {
                status: activeTab.toLowerCase(),
                ...appliedFilters
            },
            search: searchValue
        });
    };

    const handleClearFilters = () => {
        const isAlreadyEmpty =
            (!selectedInvoice || selectedInvoice.length === 0) &&
            (!selectedVendor || selectedVendor.length === 0) &&
            !purchaseInvNumber &&
            !divisionType &&
            (!staticProject || staticProject.length === 0) &&
            (!plantCode || plantCode.length === 0) &&
            !fromDate &&
            !toDate &&
            (!city || city.length === 0) &&
            (!state || state.length === 0) &&
            (!zone || zone.length === 0);

        if (isAlreadyEmpty) {
            toast.warning("No filters to reset.");
            return;
        }
        setCity([]);
        setState([]);
        setZone([]);
        setPlantCode([]);
        setSelectedInvoice([]);
        setSelectedVendor([]);
        setPurchaseInvNumber("");
        setDivisionType("");
        setStaticProject([]);
        setFilterDateRange([null, null]);
        setAppliedFilters({});
        setCurrentPage(0);
        setSkip(0);
        fetchAllCost();
    };

    const loadProjectOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/costsolution/projects/autosuggestion", {
                params: { term: inputValue || '' }
            }
            );

            const projects = res.data?.autosuggestion || [];

            if (openByArrow) {
                return projects.map(p => ({
                    label: p.label,
                    value: p.value
                }));
            }
            return projects.slice(0, 10).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error("Project suggestion error:", error);
            return [];
        }
    };

    const loadInvoiceOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/invoice/getInvnumber", {
                params: { term: inputValue || "", invoice_type: "cost" }
            });

            const invoices = res.data?.autosuggestion || [];

            return invoices.map(inv => ({
                label: inv.label,
                value: inv.value
            }));
        } catch (error) {
            console.error("Invoice autosuggestion error:", error);
            return [];
        }
    };

    const loadVendorOptions = async (inputValue) => {
        try {
            const res = await axiosInstance.get("/vendor/autosuggestion", {
                params: { term: inputValue || '' }
            });

            const data = res.data;

            if (data.success && Array.isArray(data.autosuggestion)) {
                return data.autosuggestion.map(item => ({
                    label: item.label,
                    value: item.value,
                }));
            }

            return [];
        } catch (error) {
            console.error("Vendor suggestion error:", error);
            return [];
        }
    };

    const fetchApprovalData = async (invoiceId) => {
        try {
            const response = await axiosInstance.post('/invoice/inv_approval_data', {
                invoice_id: invoiceId
            });

            if (response.data?.success) {
                return response.data.data;
            } else {
                toast.error(response.data?.message || "Failed to fetch approval data");
                return null;
            }
        } catch (error) {
            console.error("Approval data error:", error);
            toast.error("Error fetching approval data");
            return null;
        }
    };

    const formatStatus = (status) => {
        if (!status) return "";
        return status
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    const triggerFilterUpdate = (override = {}) => {
        const updatedFilters = {
            ...appliedFilters,
            status: activeTab.toLowerCase(),
            ...override
        };

        setAppliedFilters(updatedFilters);

        setCurrentPage(0);
        setSkip(0);

        fetchData({
            skip: 0,
            limit,
            type: "cost",
            filter: updatedFilters,
            search: searchTerm
        });
    };

    return (
        <>
            <Invoice_header onSearch={handleSearch} />
            <div className="container">
                <div className="invoice-header">
                    <div className="invoice-left-header">

                        <button
                            className={`invoice-btn invoice-all-btn ${activeTab === "all" ? "active" : ""}`}
                            onClick={() => setActiveTab("all")}
                        >
                            All{activeTab === "all"}
                        </button>


                        <button
                            className={`invoice-btn invoice-draft-btn ${activeTab === "draft" ? "active" : ""}`}
                            onClick={() => setActiveTab("draft")}
                        >
                            Draft{activeTab === "draft"}
                        </button>

                        <AdditionalPermissionWrapper permissionKey="submitted_cost_invoice" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-submitted-btn ${activeTab === "submitted" ? "active" : ""}`}
                                onClick={() => setActiveTab("submitted")}
                            >
                                Submitted{activeTab === "submitted"}
                            </button>
                        </AdditionalPermissionWrapper>


                        <AdditionalPermissionWrapper permissionKey="rejected_cost_invoice" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-rejected-btn ${activeTab === "rejected" ? "active" : ""}`}
                                onClick={() => setActiveTab("rejected")}
                            >
                                Rejected{activeTab === "rejected"}
                            </button>
                        </AdditionalPermissionWrapper>


                        {/* <AdditionalPermissionWrapper permissionKey="completed" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-completed-btn ${activeTab === "completed" ? "active" : ""}`}
                                onClick={() => setActiveTab("completed")}
                            >
                                Completed{activeTab === "completed" && `(${statusCounts.completed})`}
                            </button>
                        </AdditionalPermissionWrapper> */}


                        <AdditionalPermissionWrapper permissionKey="sap_pushed_cost_invoice" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-completed-btn ${activeTab === "sap pushed" ? "active" : ""}`}
                                onClick={() => setActiveTab("sap pushed")}
                            >
                                SAP Pushed{activeTab === "sap pushed"}
                            </button>
                        </AdditionalPermissionWrapper>


                        <AdditionalPermissionWrapper permissionKey="final_cost_invoice" moduleId={ModuleId}>
                            <button
                                className={`invoice-btn invoice-final-btn ${activeTab === "final invoice" ? "active" : ""}`}
                                onClick={() => setActiveTab("final invoice")}
                            >
                                Final Invoice{activeTab === "final invoice"}
                            </button>
                        </AdditionalPermissionWrapper>

                    </div>
                    <div className="right-header">
                        {showSapButton && (
                            <button
                                className="sap-push-btn"
                                onClick={handleSapPush}
                                style={{
                                    backgroundColor: '#008B1F',
                                    color: 'white',
                                    padding: '8px 16px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    marginLeft: '10px',
                                    height: '36px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}
                            >
                                SAP Push
                            </button>
                        )}

                        {showBulkSubmitButton && (
                            <button
                                className="sap-push-btn"
                                onClick={handleBulkSubmit}
                                style={{
                                    backgroundColor: '#008B1F',
                                    color: 'white',
                                    padding: '8px 16px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    marginLeft: '10px',
                                    height: '36px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}
                            >
                                Bulk Submit
                            </button>
                        )}

                        <div
                            className={`project-popup-filter-setshow-image ${showFilter ? "active" : ""}`}
                            onClick={() => setShowFilter(!showFilter)}
                        >
                            <img
                                src={filterOpenCloseIcon}
                                alt="Filter"
                                className="project-popup-filter-icon"
                                title={showFilter ? "Hide Filters" : "Show Filters"}
                            />
                        </div>

                        {/* {!isAnySelected && (
                        <>
                            <DatePicker onDateChange={handleDateSelection} />
                            <h4>Sort by :</h4>
                            <div className="dropdown">
                                <select id="options" className="dropdown-select">
                                    <option value="option1">Date Created</option>
                                    <option value="option2">Option 2</option>
                                    <option value="option3">Option 3</option>
                                </select>
                            </div>
                        </>
                    )} */}
                    </div>
                </div>

                <div className={`filteropenclose-wrapper ${showFilter ? "open" : ""}`}>
                    <CostInvoiceFilter
                        showFilters={showFilters}
                        setShowFilters={setShowFilters}
                        loadInvoiceOptions={loadInvoiceOptions}
                        loadProjectOptions={loadProjectOptions}
                        loadVendorOptions={loadVendorOptions}
                        selectedInvoice={selectedInvoice}
                        setSelectedInvoice={setSelectedInvoice}
                        staticProject={staticProject}
                        setStaticProject={setStaticProject}
                        selectedVendor={selectedVendor}
                        setSelectedVendor={setSelectedVendor}
                        fromDate={fromDate}
                        toDate={toDate}
                        setFilterDateRange={setFilterDateRange}
                        appliedFilters={appliedFilters}
                        setAppliedFilters={setAppliedFilters}
                        fetchData={fetchData}
                        limit={limit}
                        searchTerm={searchTerm}
                        activeTab={activeTab}
                        handleApply={handleApply}
                        handleClearFilters={handleClearFilters}
                        setOpenByArrow={setOpenByArrow}
                        city={city}
                        setCity={setCity}
                        state={state}
                        setState={setState}
                        zone={zone}
                        setZone={setZone}
                        plantCode={plantCode}
                        setPlantCode={setPlantCode}
                        purchaseInvNumber={purchaseInvNumber}
                        setPurchaseInvNumber={setPurchaseInvNumber}
                        divisionType={divisionType}
                        setDivisionType={setDivisionType}
                    />
                </div>

                <div className='invoice-table' style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                    <div className="records-pill">
                        Total Records:<span className="records-pill-sales">{statusCounts?.draft || 0}</span>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th style={{
                                    width: "60px",
                                    minWidth: "60px",
                                    textAlign: "center",
                                    padding: "4px"
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={isAllSelected}
                                        onChange={handleSelectAll}
                                    />
                                </th>
                                <th>Invoice No</th>
                                <th>Project</th>
                                <th>Division Type</th>
                                <th>Vendor</th>
                                {/* {activeTab === "final invoice" && <th>SAP Doc No.</th>} */}
                                <th>Quantity</th>
                                <th>Rate</th>
                                <th>Total</th>

                                <th>Current status</th>
                                <th>Next status</th>

                                <th></th>
                                {activeTab == "sap pushed" && (
                                    <th></th>
                                )}

                                {/* {activeTab == "final invoice" && (
                                    <th></th>
                                )} */}


                            </tr>
                        </thead>
                        <tbody>
                            {filteredInvoices.length > 0 ? (
                                filteredInvoices.map((invoice, index) => {
                                    // Determine if the row should be clickable (Draft status)
                                    const status = invoice.approval_status.toLowerCase();
                                    const isDraft = status === "draft" || status === "rejected";
                                    const isViewable = ["submitted", "rejected", "re-submitted", "sap pushed", "final invoice"].includes(status); // ✅ updated
                                    const rowClass = isViewable ? "clickable-row" : "";
                                    const rowStyle = isViewable ? { cursor: "pointer" } : { cursor: "default" };

                                    const handleRowClick = (e) => {
                                        if (!permission || permission.view_permission !== "1") {
                                            return;
                                        }
                                        // Ignore clicks that come from checkboxes or their labels
                                        if (e.target.tagName === 'INPUT' && e.target.type === 'checkbox') {
                                            return;
                                        }

                                        if (isViewable) {
                                            navigate("/costInvoiceViewPage", { state: { invoice } });
                                        }
                                    };

                                    return (
                                        <tr key={index} className={rowClass} style={rowStyle} onClick={handleRowClick} onMouseEnter={() => setIsHovered(invoice.id)}
                                            onMouseLeave={() => setIsHovered(null)}>
                                            <td onClick={(e) => e.stopPropagation()}>
                                                <input
                                                    style={{
                                                        width: "60px",
                                                        minWidth: "60px",
                                                        textAlign: "center",
                                                        padding: "4px"
                                                    }}
                                                    type="checkbox"
                                                    checked={selectedRows.includes(invoice.id)}
                                                    onChange={(e) => {
                                                        e.stopPropagation();
                                                        handleRowSelect(invoice.id);
                                                    }}
                                                    onClick={(e) => e.stopPropagation()} // Add this
                                                />
                                            </td>
                                            <td>{invoice.inv_number}</td>
                                            <td>
                                                {(() => {
                                                    const projects = invoice.project
                                                        ? invoice.project.split(",").map(p => p.trim())
                                                        : [];

                                                    const visibleProjects = projects.slice(0, 2);
                                                    const remainingCount = projects.length - 2;

                                                    return (
                                                        <div
                                                            className="project-cell"
                                                            title={projects.join(", ")}
                                                        >
                                                            {visibleProjects.join(", ")}

                                                            {remainingCount > 0 && (
                                                                <span className="more-projects">
                                                                    {" "}+{remainingCount} more
                                                                </span>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>{invoice.division_type?.toUpperCase() || "--"}</td>
                                            <td>{invoice.vendor_name}</td>
                                            {/* {activeTab === "final invoice" && <td>{invoice.sap_doc_no}</td>} */}
                                            <td>{invoice.inv_quantity}</td>
                                            <td>{invoice.inv_rate}</td>
                                            <td>{invoice.inv_amount}</td>

                                            <td>
                                                <button className={`invoice-status-button ${status}`}>
                                                    {formatStatus(invoice.approval_status)}
                                                </button>
                                            </td>
                                            <td>{invoice.next_status}</td>

                                            {activeTab == "sap pushed" && (
                                                <td>
                                                    <div className='invoice-csv-file-downloads'
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "6px",
                                                            padding: "6px 12px",
                                                            borderRadius: "9999px", // Full pill shape
                                                            border: "1px solid #ccc",
                                                            cursor: "pointer",
                                                            fontWeight: "500",
                                                            width: "fit-content",
                                                            userSelect: "none"
                                                        }}
                                                        onClick={async (e) => {
                                                            e.stopPropagation();
                                                            try {
                                                                const response = await axiosInstance.post(`/cost_csv_generate/${invoice.id}`);
                                                                console.log("response", response);
                                                                const fileUrl = response?.data?.file_url;

                                                                if (fileUrl) {
                                                                    const fileName = fileUrl.split('/').pop(); // Extracts 'SI20250627007_variable.csv'
                                                                    // This avoids CORS issues — triggers a direct browser download
                                                                    const link = document.createElement('a');
                                                                    link.href = fileUrl;
                                                                    // link.setAttribute('download', `invoice_${invoice.id}.csv`);
                                                                    link.setAttribute('download', fileName);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                } else {
                                                                    toast.error("File URL not found.");
                                                                }
                                                            } catch (error) {
                                                                console.error("Download failed:", error);
                                                                toast.error("Failed to download cost invoice file.");
                                                            }
                                                        }}
                                                    >
                                                        <img
                                                            src={download_arrow}
                                                            alt="Download"
                                                            className="downloads_icon"
                                                            style={{ width: "16px", height: "16px" }}
                                                        />
                                                        <span>CSV</span>
                                                    </div>
                                                </td>
                                            )}

                                            {activeTab == "final invoice" && (
                                                <>
                                                    <td>
                                                        <div className='invoice-csv-file-downloads'
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                padding: "6px 12px",

                                                                borderRadius: "9999px",
                                                                border: "1px solid #ccc",
                                                                cursor: "pointer",
                                                                fontWeight: "500",
                                                                width: "fit-content",

                                                            }}
                                                            onClick={async (e) => {
                                                                e.stopPropagation();
                                                                try {
                                                                    const response = await axiosInstance.post(`/cost_csv_generate/${invoice.id}`);
                                                                    const fileUrl = response?.data?.file_url;

                                                                    if (fileUrl) {
                                                                        const fileName = fileUrl.split('/').pop();
                                                                        const link = document.createElement('a');
                                                                        link.href = fileUrl;
                                                                        // link.setAttribute('download', `invoice_${invoice.id}.csv`);
                                                                        link.setAttribute('download', fileName);
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                        document.body.removeChild(link);
                                                                    } else {
                                                                        toast.error("File URL not found.");
                                                                    }
                                                                } catch (error) {
                                                                    console.error("Download failed:", error);
                                                                    toast.error("Failed to download invoice file.");
                                                                }
                                                            }}
                                                        >
                                                            <img
                                                                src={download_arrow}
                                                                alt="Download"
                                                                className="downloads_icon"
                                                                style={{ width: "16px", height: "16px" }}
                                                            />
                                                            <span>CSV</span>
                                                        </div>
                                                    </td>

                                                    {/* <td>
                                                    <div className='invoice-inv-file-downloads'
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "6px",
                                                            padding: "6px 12px",
                                                            borderRadius: "9999px", // Full pill shape
                                                            border: "1px solid #ccc",
                                                            cursor: "pointer",
                                                            fontWeight: "500",
                                                            width: "fit-content",
                                                            userSelect: "none"
                                                        }}
                                                        onClick={async (e) => {
                                                            e.stopPropagation();
                                                            try {
                                                                const response = await axiosInstance.post(`/final_invoice_file/${invoice.id}`);
                                                                console.log("final invoice response", response);
                                                                const fileUrl = response?.data?.file_url;

                                                                if (fileUrl) {
                                                                    // This avoids CORS issues — triggers a direct browser download
                                                                    const link = document.createElement('a');
                                                                    link.href = fileUrl;
                                                                    // link.setAttribute('download', `invoice_${invoice.id}.csv`);
                                                                    const fileExtension = fileUrl.split('.').pop().toLowerCase();
                                                                    link.setAttribute('download', `invoice_${invoice.id}.${fileExtension}`);
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                } else {
                                                                    alert("File URL not found.");
                                                                }
                                                            } catch (error) {
                                                                console.error("Download failed:", error);
                                                                alert("Failed to download invoice file.");
                                                            }
                                                        }}>
                                                        <img
                                                            src={download_arrow}
                                                            alt="Download"
                                                            className="downloads_icon"
                                                            style={{ width: "16px", height: "16px" }}
                                                        />
                                                        <span>INV</span>
                                                    </div>
                                                </td> */}

                                                </>
                                            )}

                                            <td>
                                                {isDraft && (
                                                    <div className="actions" onClick={(e) => e.stopPropagation()}>

                                                        <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                                                            <span className="edit-icon" style={{ cursor: "pointer" }}>
                                                                <img
                                                                    src={Vector}
                                                                    onClick={createClickHandler(invoice)}
                                                                    alt="Edit Icon"
                                                                    width="20"
                                                                    height="20"
                                                                />
                                                            </span>
                                                        </PermissionWrapper>


                                                        <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                                                            <span className="delete-icon">
                                                                <img src={Delete} alt="Delete Icon" width="40" height="40" onClick={() => handleDelete(invoice.id)} />
                                                            </span>
                                                        </PermissionWrapper>
                                                    </div>

                                                )}

                                                {(invoice.show_button && isHovered === invoice.id) && (
                                                    <div
                                                        className="action-icons"
                                                        style={{
                                                            display: 'flex',
                                                            gap: '10px',
                                                        }}
                                                    >
                                                        <button
                                                            className="ticket-icon"
                                                            title="Approve Invoice"
                                                            style={{
                                                                width: '24px',
                                                                height: '24px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#f0f0f0',
                                                                border: 'none',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <img style={{ width: '20px', height: '20px' }} onClick={() => openModal('approved', invoice)} src={checked_icon} alt='' />
                                                        </button>
                                                        <button
                                                            className="remove-icon"
                                                            title="Reject Invoice"
                                                            style={{
                                                                width: '24px',
                                                                height: '24px',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#f0f0f0',
                                                                border: 'none',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <img style={{ width: '20px', height: '20px' }} onClick={() => openModal('rejected', invoice)} src={removed_icon} alt='' />
                                                        </button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })) : (
                                <tr>
                                    {searchTerm && filteredInvoices.length === 0 && (
                                        <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                                            No Cost Invoice found matching "{searchTerm}"
                                        </td>
                                    )}
                                </tr>
                            )}
                        </tbody>


                    </table>
                </div>

                <CommonPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    limit={limit}
                    onPageChange={handlePageClick}
                    onLimitChange={handleLimitChange}
                />
            </div>

            <ConfirmDialog
                open={confirmOpen}
                title="Delete Confirmation"
                message="Are you sure you want to delete this Invoice?"
                confirmText="Delete"
                cancelText="Cancel"
                onConfirm={confirmDelete}
                onCancel={cancelDelete}
            />
            <ConfirmDialog
                open={confirmBulkSubmitOpen}
                title="Bulk Submit Invoices"
                message={`Are you sure you want to submit ${selectedRows.length} selected invoices?`}
                confirmText="Submit"
                cancelText="Cancel"
                onConfirm={confirmBulkSubmit}
                onCancel={cancelBulkSubmit}
            />
            <CommonFooter />
            {isModalOpen && approvalData && (
                <CostApproveRejectPopup
                    isOpen={isModalOpen}
                    onClose={closeModal}
                    actionType={actionType}
                    invoice={{ approvalData }}
                    isLoading={isActionLoading}
                    onSubmit={(data) =>
                        handleInvoiceAction(
                            activeInvoice.id,
                          activeInvoice.project_ids,
                            activeInvoice.vendor_id,
                            data
                        )
                    }
                />
            )}
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
        </>
    )
}

export default CostInvoice
